var React = require('react');

function IconArrowCollapse (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M400.3 689c-4.7 0-9.3-1.8-12.9-5.3-.4-.4-40-39.9-79.6-79.6-81.5-81.8-83.2-84.6-84.9-87.3-7.8-12.5-4.2-25.6 2.4-32.4l162-164c7.1-7.2 18.6-7.2 25.8-.2 7.2 7.1 7.2 18.6.2 25.8L258.8 502.4c22.9 23.9 102.9 104.2 154.4 155.5 7.1 7.1 7.2 18.7 0 25.8-3.5 3.5-8.2 5.3-12.9 5.3zM252.9 496zM765.8 366.5H504.5c-10.1 0-18.2-8.2-18.2-18.2 0-10.1 8.2-18.2 18.2-18.2h261.2c10.1 0 18.2 8.2 18.2 18.2.1 10-8.1 18.2-18.1 18.2zM765.8 515.3H504.5c-10.1 0-18.2-8.2-18.2-18.2 0-10.1 8.2-18.2 18.2-18.2h261.2c10.1 0 18.2 8.2 18.2 18.2.1 10.1-8.1 18.2-18.1 18.2zM765.8 664.2H504.5c-10.1 0-18.2-8.2-18.2-18.2 0-10.1 8.2-18.2 18.2-18.2h261.2c10.1 0 18.2 8.2 18.2 18.2.1 10-8.1 18.2-18.1 18.2z"}));
}

IconArrowCollapse.displayName = "IconArrowCollapse";

IconArrowCollapse.defaultProps = {"viewBox":"0 0 1000.6 1000.7"};

module.exports = IconArrowCollapse;

IconArrowCollapse.default = IconArrowCollapse;
